export default [
  "Academic writing",
  "Accounting and Reporting",
  "Art Design",
  "Auditing",
  "Business Plan Preparation and Evaluation",
  "Career Development and Coaching",
  "Client service/communications",
  "Contract drafting",
  "Corporate Governance",
  "Data analysis",
  "Database Design and Management",
  "Data capturing",
  "Event Management",
  "Financial Analysis",
  "Financial Budgeting, Planning and Reporting",
  "Financial modelling",
  "Graphic Design",
  "Interviewing Skills",
  "Investment analysis",
  "IT Support Troubleshooting",
  "Legal advice",
  "Legislation and Compliance",
  "Marketing Communications",
  "Marketing Strategy and Planning",
  "Market Research \u0026 Analysis",
  "Photo retouching",
  "Positioning \u0026 Branding",
  "Pricing",
  "Product Development",
  "Programming",
  "Project management",
  "Public Relations",
  "Report writing",
  "Sales",
  "Strategic Planning",
  "Tutoring",
  "Web Design"
]
